export default function (date) {
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const adjustment = Math.ceil(minutes / 30)
  const gap = (hours * 4) + (adjustment === 2 ? adjustment : 0) + 1

  return gap
}
